import request from './request'

const uploadApi = {
  uploadImage (data) {
    return request.post('/file/upload', data)
  },
}

export default uploadApi
